// extracted by mini-css-extract-plugin
export default {"section":"social-sections-UgcActionSection__section--3rHoM","header":"social-sections-UgcActionSection__header--2rdu0"};